var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPokt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1E8AED",
    d: "M8.571 11.52c0-2.846 2.55-3.514 4.286-3.369V5.194a6.857 6.857 0 0 0-3 13.32v-2.558a1.375 1.375 0 0 1 1.393-1.384h.784c1.881 0 2.108-1.77 2.108-2.092c0-.219-.09-.42-.192-.643a3 3 0 0 1-.146-.343a.69.69 0 0 1 .137-.672l.69-.536c.49.63.768 1.397.797 2.194c0 2.846-2.55 3.514-4.286 3.369v2.957a6.856 6.856 0 0 0 3-13.32v2.558A1.377 1.377 0 0 1 12.75 9.43h-.785c-1.881 0-2.108 1.77-2.108 2.091c0 .219.09.42.193.643q.079.159.145.343a.69.69 0 0 1-.137.673l-.69.535a3.8 3.8 0 0 1-.797-2.194"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPokt);
export default __webpack_public_path__ + "static/media/pokt.f09095d913aabd9f52f1bf1bd8e05b4a.svg";
export { ForwardRef as ReactComponent };